<template>
	<div class="product-info" v-bind:style="getProductStyle"  @click="productClick">
    <img class="product-icon"  v-bind:style="getProductLabelStyle"   src='../../../assets/image/activity/goodProject@2x.png'>
    <img class="product-icon" v-bind:style="getProductIconStyle" :src="item.default_photo.large"  v-if='item.default_photo'>
    <img class="product-icon" v-bind:style="getProductIconStyle" src="../../../assets/image/change-icon/default_image_02@2x.png" v-else>
    <span class="product-title" v-bind:style="getProductNameStyle">{{ toNewName(item.name) }}</span>
    <div class="product-bottom">
      <span class="product-price">￥{{item.current_price || item.price}}</span>
      <span class="product-underline">{{ utils.getUnderLinePrice(item)}}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HomeProductBody',
  data() {
    return {
      itemWidth : 0,
      itemHeight : 0,
      showRightBorder: this.index % 2 == 0,
    };
  },
  props: ['item', 'index'],
  computed: {
    getProductStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width / 3 - 20 - 1;
      let itemHeight = itemWidth * (132.0 / 84.0);
      this.itemWidth = itemWidth;
      this.itemHeight = itemHeight;
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
    getProductLabelStyle:function(){
      const { width, height } = window.screen
      let itemWidth = (this.itemWidth - 20)/4;
      let itemHeight = itemWidth;
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px',
        'margin-bottom': - itemHeight + 'px',
        'margin-left': - (this.itemWidth/2+itemWidth-10) + 'px',
        'align-self': 'left',
        'z-index': 300
      }
    },
    getProductNameStyle: function () {
      const { width, height } = window.screen
      let itemWidth = this.itemWidth - 20;
      let itemHeight = itemWidth;
      return {
        width: itemWidth + 'px',
        // height: itemHeight + 'px'
      }
    },
    getProductIconStyle: function () {
      const { width, height } = window.screen
      let itemWidth = this.itemWidth - 20;
      let itemHeight = itemWidth;
      return {
        width: itemWidth + 'px',
        height: itemHeight + 'px'
      }
    },
  },
  methods: {
    productClick: function() {
      this.$router.push({'name': 'product', 'query': {'id': this.item.id}});
    },
    toNewName(name){
      const { width, height } = window.screen
      let itemWidth = this.itemWidth - 20;
      let wordNumber = Math.floor(itemWidth/14)
      // console.log("name="+name+",itemWidth="+itemWidth+",wordNumber="+wordNumber)
      // if(name && name.length > wordNumber){
      //   return name.substring(0,wordNumber)+'...'
      // }else{
        return name
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.product-info {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 10px;
  justify-content: flex-end;
  .product-icon {
    align-self: center;
  }
  .product-title {
    color: #333333;
    font-size: 14px;
    // height:30px;
    margin-top: 10px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .product-bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 6px;
    .product-price {
      color: #666666;
      font-size: 12px;
    }
    .product-buy {
      color: #999999;
      font-size: 12px;
    }
    .product-underline {
      color: #b8b8b8;
      font-size: 11px;
      text-decoration: line-through;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/page/home/child/HomeProductBody.vue